import React from "react";
import { Spinner } from "flowbite-react";

const Loader = ({ styles }) => {
  return (
    <div
      className={`flex items-center justify-center w-screen h-screen ${styles}`}
    >
      <div className="text-center">
        <Spinner aria-label="Center-aligned spinner example" size="xl" />
      </div>
    </div>
  );
};

export default Loader;
